export class MemberSearchRequestDTO {
    // Base infos
    userId: number | null;
    loginId: string;
    firstName: string;
    lastName: string;
    email: string;
    ipAddress: string;

    // Company infos
    companyName: string;
    vatNumber: string;
    phone: string;
    zipString: string;
    language: number | null;

    // User group and status
    userGroupId: number | null;
    priceSystem: number | null;
    status: number | null;
    blockReason: number | null;
    paymentsOk: boolean | null;
    invoiceMethod: number | null;

    // Business types and affiliates
    businessTypes: number[] | [];
    affiliateIds: number[] | [];
    /**
     * Filter by business type TYPE (not specific IDs).
     * Value specifies which TYPE to check for: 1 = RFP types, 2 = PPP/Partner types, etc.
     * Filters for users that have at least one business type with the specified TYPE.
     */
    businessTypeType: number | null;

    // Company details
    companyType: string;
    companyFunction: string[] | [];
    department: string[] | [];
    industryArea: number[] | [];
    minEmployees: number | null;
    maxEmployees: number | null;

    constructor(data?: any) {
        // Base infos
        this.userId = data?.userId || null;
        this.loginId = data?.loginId || '';
        this.firstName = data?.firstName || '';
        this.lastName = data?.lastName || '';
        this.email = data?.email || '';
        this.ipAddress = data?.ipAddress || '';

        // Company infos
        this.companyName = data?.companyName || '';
        this.vatNumber = data?.vatNumber || '';
        this.phone = data?.phone || '';
        this.zipString = data?.zipString || '';
        this.language = data?.language || null;

        // User group and status
        this.userGroupId = data?.userGroupId || null;
        this.priceSystem = data?.priceSystem || null;
        this.status = data?.status || null;
        this.blockReason = data?.blockReason || null;
        this.paymentsOk = data?.paymentsOk ?? null;
        this.invoiceMethod = data?.invoiceMethod || null;

        // Business types and affiliates
        this.businessTypes = data?.businessTypes || [];
        this.affiliateIds = data?.affiliateIds || [];
        this.businessTypeType = data?.businessTypeType || null;

        // Company details
        this.companyType = data?.companyType || '';
        this.companyFunction = data?.companyFunction || [];
        this.department = data?.department || [];
        this.industryArea = data?.industryArea || [];
        this.minEmployees = data?.minEmployees || null;
        this.maxEmployees = data?.maxEmployees || null;
    }
} 